module.exports = __webpack_public_path__ + "img/base_img_couponbg01@2x.06b460e9.png";